"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFINITION_PROP_NAMES = void 0;
var DEFINITION_PROP_NAMES;
(function (DEFINITION_PROP_NAMES) {
    DEFINITION_PROP_NAMES["OPTIONS"] = "0";
    DEFINITION_PROP_NAMES["FREE"] = "1";
    DEFINITION_PROP_NAMES["DESCRIPTION"] = "a";
    DEFINITION_PROP_NAMES["MAP_TYPE"] = "b";
    DEFINITION_PROP_NAMES["MAP_OPTIONS"] = "c";
    DEFINITION_PROP_NAMES["URL_SETTINGS"] = "d";
    DEFINITION_PROP_NAMES["ALL_FUNCTIONS"] = "e";
    DEFINITION_PROP_NAMES["APP_PROCESSES"] = "f";
    DEFINITION_PROP_NAMES["RAW_STRING"] = "g";
    DEFINITION_PROP_NAMES["ENTRY_VARS"] = "h";
    DEFINITION_PROP_NAMES["ENTRIES"] = "i";
    DEFINITION_PROP_NAMES["INTERPOLATION"] = "j";
    DEFINITION_PROP_NAMES["PATH_ENTRIES"] = "k";
    DEFINITION_PROP_NAMES["CATCH"] = "l";
    DEFINITION_PROP_NAMES["URL"] = "m";
    DEFINITION_PROP_NAMES["METHOD"] = "n";
    DEFINITION_PROP_NAMES["GET"] = "o";
    DEFINITION_PROP_NAMES["POST"] = "p";
    DEFINITION_PROP_NAMES["THEN"] = "q";
    DEFINITION_PROP_NAMES["QUERY_PARAMS"] = "r";
    DEFINITION_PROP_NAMES["DATA"] = "s";
    DEFINITION_PROP_NAMES["QUERY_METHOD"] = "t";
    DEFINITION_PROP_NAMES["HEADERS"] = "u";
    DEFINITION_PROP_NAMES["DELETE"] = "v";
    DEFINITION_PROP_NAMES["HEAD"] = "w";
    DEFINITION_PROP_NAMES["PUT"] = "x";
    DEFINITION_PROP_NAMES["PATCH"] = "y";
    DEFINITION_PROP_NAMES["PURGE"] = "z";
    DEFINITION_PROP_NAMES["LINK"] = "A";
    DEFINITION_PROP_NAMES["UNLINK"] = "B";
    DEFINITION_PROP_NAMES["NAME"] = "C";
    DEFINITION_PROP_NAMES["CONTENT"] = "D";
    DEFINITION_PROP_NAMES["ARRAY"] = "E";
    DEFINITION_PROP_NAMES["PREDICATE"] = "F";
    DEFINITION_PROP_NAMES["FILTER_PREDICATE"] = "G";
    DEFINITION_PROP_NAMES["VALUE"] = "H";
    DEFINITION_PROP_NAMES["ALLOW_RECURSIVE_OBJECTS"] = "I";
    DEFINITION_PROP_NAMES["ERROR_VALUE"] = "J";
    DEFINITION_PROP_NAMES["OBJECT1"] = "K";
    DEFINITION_PROP_NAMES["OBJECT2"] = "L";
    DEFINITION_PROP_NAMES["PATH"] = "M";
    DEFINITION_PROP_NAMES["OBJECT"] = "N";
    DEFINITION_PROP_NAMES["CODE"] = "O";
    DEFINITION_PROP_NAMES["ARGS"] = "P";
})(DEFINITION_PROP_NAMES = exports.DEFINITION_PROP_NAMES || (exports.DEFINITION_PROP_NAMES = {}));
